import { setSessionStorageRecord } from 'application';
import { HOME_HEALTH_LIST_CONTEXT_SESSION_KEY } from '.';

export type HomeHealthAction =
  | { type: 'setHomeHealthFilters'; value?: any }
  | { type: 'setHomeHealthDefaultFiltersApplied'; value?: any }

export type HomeHealthState = {
  homeHealthFilters?: any;
  homeHealthDefaultFiltersApplied?: boolean;
};
export const homeHealthDefaultState: HomeHealthState = {};

export function homeHealthReducer(homeHealthState: HomeHealthState, homeHealthAction: HomeHealthAction): HomeHealthState {
  switch (homeHealthAction.type) {
    case 'setHomeHealthFilters': {
      const updatedHomeHealthState = { ...homeHealthState, homeHealthFilters: homeHealthAction.value };
      setSessionStorageRecord(HOME_HEALTH_LIST_CONTEXT_SESSION_KEY, updatedHomeHealthState);
      return updatedHomeHealthState;
    }
    case 'setHomeHealthDefaultFiltersApplied': {
      const updatedHomeHealthState = { ...homeHealthState, homeHealthDefaultFiltersApplied: homeHealthAction.value };
      setSessionStorageRecord(HOME_HEALTH_LIST_CONTEXT_SESSION_KEY, updatedHomeHealthState);
      return updatedHomeHealthState;
    }
    default:
      return homeHealthState;
  }
}
